import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------
const DedupePage = (props) => {
  const { leadId, id } = useParams();
  const location = useLocation();
  const {leadInfo, actions, usersData, fetchLeadIdBankStatement,crifDetails ,dedupeMatchesDetails,btnOpenDedupeData,runCustomerDedupeHistory} = props;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate(); 
  const [isInitialized, setIsInitialized] = useState(false);
  const [crifAccountInformationArr, setCrifAccountInformationArr] = useState([]);
   

  const [formCAMValues, setFormCAMValues] = useState({
    addressTypeId: '1'
  });
   
    
  useEffect(() => { 
    const crifAccountInformation = dedupeMatchesDetails || [];  
      setCrifAccountInformationArr(crifAccountInformation);
      setIsInitialized(true); // Add a flag to prevent re-execution  
      // console.log("crifAccountInformation = ", crifAccountInformation);
     
  }, [crifDetails, isInitialized,dedupeMatchesDetails]); 

  return (
    <>
      <div id="main-wrap" className='mt-1 cam_section'>
        <div className='row justify-content-between'>
          <div className="row">
            <div className='col-md-12'>
             {/* <h5>Customer Dedupe</h5> */ }

              <div className="text-right float-right">
                 <div className='form-group text-end mb-2'>
                     <button className="btn btn-primary" type="button" onClick={() => btnOpenDedupeData('4')} > Run Dedupe</button>  
                </div>
                {(runCustomerDedupeHistory?.[0]?.created_at !=='' && runCustomerDedupeHistory?.[0]?.created_at !== undefined) ? `Customer Dedupe Run By ${runCustomerDedupeHistory[0]?.createdByName} On ${runCustomerDedupeHistory[0]?.created_at}` : ""}&nbsp;
 
                

              </div>
              <table border="1" className="table">
              <thead>
                <tr>
                    <th>Customer Name</th>	
                    <th>Mobile</th>	
                    <th>Matched With</th>	
                    <th>Loan Number</th>
                    <th>Match Type</th>		
                    <th>Match Fields</th>
                   	                    
                  {/*  <th>Approve/ Reject</th>	*/ }
                  </tr>
                </thead>
                <tbody>
                {crifAccountInformationArr.map((row, index) => (
                   <tr key={index}>
                  
                      <td> 
                        <b>Applicant </b> : <a
                        href={`/dashboard/edit-lead/${btoa(String(row?.actual_lead_id))}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#007bff', textDecoration: 'none', cursor: 'pointer' }}
                      >
                      {row.lead_name} 
                      </a> 
                      </td>
                      <td>{row.matched_mobile}</td>
                      <td> 
                         {row.section_name === 'guarantor' ? (<><b>Guarantor</b> : {row.matched_name}</>) : (row.section_name === 'coApplicant' ? (<><b>Co-applicant</b> : {row.matched_name}</>) : (<><b>Applicant</b> : {row.matched_name}</>))} 
                      </td>
                      <td>{row.AgreementNo}</td>
                      <td>{row.match_type}</td>
                      <td>{row.match_fields}</td>
                       
                    {/*  <td>
                        <button className="btn btn-success" type="button" > Approve </button>
                        <button className="btn btn-danger" type="button" > Reject </button>
                      </td> */ }
                       

                  </tr>
                    ))}

                </tbody>

                </table>
            </div>
          </div>
         </div>
      </div>
    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DedupePage);
